import React, { FC } from 'react';

import { Stack, Typography, useDesktop, useMediaSwitch, useMobile } from 'Modules/ui3';

import { ASK_EMAIL, OPERATOR_EMAIL, PARTNER_EMAIL, PR_EMAIL } from '../../../../constants';


const CONTACTS = [
    {
        email: ASK_EMAIL,
        description: 'Выпуск и покупка ЦФА',
    },
    {
        email: OPERATOR_EMAIL,
        description: 'Информационная поддержка',
    },
    {
        email: PARTNER_EMAIL,
        description: 'Партнерская программа',
    },
    {
        email: PR_EMAIL,
        description: 'для СМИ',
    },
];


export const Contacts: FC = () => {
    const isDesktop = useDesktop();
    const isMobile = useMobile();

    const descriptionVariant = useMediaSwitch('regularBody2', 'regularCaption1', 'regularCaption3');
    const contactWidth = useMediaSwitch('50%', '223px', '165px');

    return (
        <Stack
            height='100%'
            width='100%'
        >
            <Typography
                variant={isMobile ? 'regularCaption1' : 'regularBody2'}
                color='grayscale.shade95'
                mb={4}
            >
                Контакты
            </Typography>

            <Stack
                height='100%'
                direction='row'
                sx={{
                    flexWrap: 'wrap',
                }}
                justifyContent='space-between'
            >
                {CONTACTS.map(({ email, description }, index) => (
                    <Stack
                        width={contactWidth}
                        key={index}
                        mb={3}
                    >
                        <Typography
                            component='a'
                            href={`mailto:${email}`}
                            variant={isDesktop ? 'regularHeader2' : 'regularBody2'}
                            lineHeight={isDesktop ? '1.5' : '1.4'}
                        >
                            {email}
                        </Typography>

                        <Typography variant={descriptionVariant} color='grayscale.shade90'>
                            {description}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};
